import React from 'react'

export default function QuestionMark(props) {
	return (
		<svg
			width={18}
			height={18}
			viewBox="0 0 18 18"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Question Mark</title>
			<g fill="#B4B8BC" fillRule="evenodd" opacity="1">
				<path d="M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-1A8 8 0 1 0 9 1a8 8 0 0 0 0 16z" />
				<path d="M8.19 10.898v-.375c0-.43.078-.787.234-1.072.156-.285.43-.58.82-.885.465-.367.765-.652.9-.855a1.29 1.29 0 0 0 .202-.727c0-.328-.11-.58-.328-.755-.22-.176-.534-.264-.944-.264-.37 0-.715.053-1.031.158a7.32 7.32 0 0 0-.926.38l-.492-1.03a5.158 5.158 0 0 1 2.549-.662c.765 0 1.373.187 1.822.562.45.375.674.893.674 1.553 0 .293-.043.553-.129.782a2.245 2.245 0 0 1-.39.653c-.173.207-.473.477-.899.809-.363.285-.606.521-.73.709-.123.187-.184.44-.184.756v.263H8.189zm-.24 1.87c0-.59.286-.885.86-.885.282 0 .497.077.645.231.149.155.223.372.223.654 0 .277-.075.497-.226.659-.15.162-.364.243-.641.243-.278 0-.49-.08-.64-.237-.148-.159-.222-.38-.222-.665z" />
			</g>
		</svg>
	)
}
